// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3ZjV7","content":"ManualTimeModal_content__mNsvk"};